import React from "react";
import PropTypes from "prop-types";
// import { get } from "lodash";

import { addAdsToTemplates } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import { GA, WebEngage, ComScore } from "../../integrations";
import { DfpAd } from "../atoms/dfp-ad";

import styles from "./webstories.m.css";

const newTemplates = addAdsToTemplates("home");
function getAdsWrappedCollectionTemplate() {
  return newTemplates["slider-web-stories-card"];
}

export class WebstoriesPage extends React.Component {
  componentDidMount() {
    GA.registerPageView(this.props.pageType, {});
    WebEngage.registerPageView();
    ComScore.registerPageView();
  }

  render() {
    return (
      <React.Fragment>
        <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
          <DfpAd
            className="hidden-mobile ad-tower-left"
            adtype="Tower_Left"
            placement="storyfeed"
            slotId="tower-left-1"
          />
          <div className="page-content infinity-page">
            <div className={`container ${styles["story-grid"]}`}>
              <div className={styles["main-content"]}>
                <LazyCollection
                  collection={this.props.data.collection}
                  magazine={this.props.data.magazine}
                  config={this.props.config}
                  collectionTemplates={getAdsWrappedCollectionTemplate}
                  lazyAfter={10}
                  accentColor={"#404040"}
                  numberOfCardsInViewDesktop={2}
                />
              </div>
              <aside className={styles.sidebar}>
                <div className={`${styles["ad-wrapper"]} hidden-mobile`}>
                  <DfpAd adtype="Rectangle" placement="story" slotId="story-sidebar-1" />
                </div>

                <DfpAd adtype="Half_Page" placement="story" slotId="story-sidebar-2" />
              </aside>
            </div>
          </div>

          <DfpAd
            className="hidden-mobile ad-tower-right"
            adtype="Tower_Right"
            placement="storyfeed"
            slotId="tower-right-1"
          />
        </div>
      </React.Fragment>
    );
  }
}

WebstoriesPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
